import { useEffect, useState, useCallback, useRef } from "react";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
import dataTableData from "./data/dataTableData";
import { RequestService } from "services/RequestService";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";
import MDBadge from "components/MDBadge";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useNavigate } from "react-router-dom";
import Icon from "@mui/material/Icon";
import CustomNavbar from "components/CustomNavbar";

function IssuesDataTables() {
  const navigate = useNavigate();
  const [dataTableData2, setDataTableData] = useState(dataTableData);
  const [show, setShow] = useState(false);
  const [error, setError] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [issueIdToDelete, setissueIdToDelete] = useState(null);
  const [projectId, setProjectId] = useState(null);
  const urlParams = new URLSearchParams(window.location.search);
  const id = urlParams.get("id");
  const toggleSnackbar = () => setShow(!show);
  const toggleSnackbar2 = () => setError(!error);
  const [projectName, setProjectName] = useState("");
  const [response, setResponse] = useState(null);

  const handleOpenDialog = (id) => {
    setissueIdToDelete(id);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setissueIdToDelete(null);
  };

  const handleConfirmDelete = async () => {
    if (issueIdToDelete) {
      try {
        const result = await RequestService.delete(`Issue/${issueIdToDelete}/${id}`);
        if (result.status === 200) {
          toggleSnackbar();
          fetchIssues();
        } else {
          toggleSnackbar2();
        }
      } catch (error) {
        console.error("Error deleting issue:", error);
        toggleSnackbar2();
      }
      handleCloseDialog();
    }
  };

  const getPriorityBadge = (priority) => {
    const priorityConfig = {
      0: { color: "info", label: "منخفضة" },
      1: { color: "warning", label: "متوسطة" },
      2: { color: "error", label: "عالية" },
      3: { color: "error", label: "حرجة" }
    };

    const config = priorityConfig[priority] || { color: "default", label: "غير معروف" };

    return (
      <MDBadge
        variant="gradient"
        color={config.color}
        size="sm"
        badgeContent={config.label}
        container
      />
    );
  };

  const getStatusBadge = (status) => {
    const statusConfig = {
      0: { color: "error", label: "غير نشط" },
      1: { color: "success", label: "نشط" }
    };

    const config = statusConfig[status] || { color: "default", label: "غير معروف" };

    return (
      <MDBadge
        variant="gradient"
        color={config.color}
        size="sm"
        badgeContent={config.label}
        container
      />
    );
  };

  const fetchIssues = async () => {
    try {
      const response = await RequestService.get(`Issue/${id}`);
      if (response.data.error === false) {
        const projectData = response.data.data.map((r, index) => {
          setProjectName(r.projectName);
          r.progress = r.progress + "%";
          // Add badges for priority and status
          r.priority = getPriorityBadge(parseInt(r.priority));
          r.status = getStatusBadge(parseInt(r.status));
          r.actions = (
            <MDBox display="flex" alignItems="center" gap={1}>
                <MDButton
                variant="gradient"
                color="info"
                size="small"
                onClick={() => {
                  navigate(`/pages/projects/issues/edit?id=${r.id}&projectId=${id}`);
                }}
                startIcon={<Icon>edit</Icon>}
              >
                تعديل
              </MDButton>
              <MDButton
                variant="outlined"
                color="error"
                size="small"
                onClick={() => handleOpenDialog(r.id)}
                startIcon={<Icon>delete</Icon>}
              >
                حذف
              </MDButton>
            
            </MDBox>
          );
          r["#"] = index + 1;
          return r;
        });

        setDataTableData((prevState) => ({
          ...prevState,
          rows: projectData,
        }));
        setResponse(response);
      }
    } catch (error) {
      console.error("Error fetching issues:", error);
    }
  };

  useEffect(() => {
    setProjectId(id);
    fetchIssues();
  }, []);

  return (
    <DashboardLayout>
      <CustomNavbar
        title={`قضايا مشروع ${projectName}`}
        route={[
          { path: "pages/projects/viewprojects", display: "المشاريع" },
          { path: `projectinfo?id=${id}`, display: projectName },
          { path: id, display: "تفاصيل المشروع" }
        ]}
      />
      <MDSnackbar
        color="success"
        icon="notifications"
        title="تم اتمام العملية"
        content="تم اتمام العملية بنجاح"
        dateTime="منذ 0 ثانية"
        open={show}
        close={toggleSnackbar}
      />

      <MDSnackbar
        color="error"
        icon="notifications"
        title="اضافة "
        content="حدث خطأ ما"
        dateTime="منذ 0 ثانية"
        open={error}
        close={toggleSnackbar2}
      />
      <MDBox pt={6} pb={3}>
        <Card>
          <MDBox p={3} lineHeight={1} display="flex" flexDirection="column">
            <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
              <MDTypography variant="h5" fontWeight="medium">
                مشكلات المشروع
              </MDTypography>
              <MDButton
                onClick={() => {
                  navigate(`/pages/projects/issues/add?projectId=${id}`);
                }}
                color="info"
                variant="gradient"
                size="small"
              >
                اضافة مشكلة جديدة
              </MDButton>
            </MDBox>
            
            <MDBox 
              display="flex" 
              flexDirection="column" 
              bgcolor="grey.100" 
              p={2} 
              borderRadius="lg"
            >
              <MDBox display="flex" alignItems="center" mb={2}>
                <MDTypography variant="h6" fontWeight="medium" color="text">
                  اسم المشروع:
                </MDTypography>
                <MDTypography variant="h6" fontWeight="regular" ml={1}>
                  {projectName}
                </MDTypography>
              </MDBox>

              <MDBox display="flex" gap={3}>
                <MDBox>
                  <MDTypography variant="button" color="text" fontWeight="regular">
                    حالة المشكلات:
                  </MDTypography>
                  <MDBox display="flex" gap={1} mt={0.5}>
                    {getStatusBadge(0)}
                    {getStatusBadge(1)}
                  </MDBox>
                </MDBox>

                <MDBox>
                  <MDTypography variant="button" color="text" fontWeight="regular">
                    مستوى الأولوية:
                  </MDTypography>
                  <MDBox display="flex" gap={1} mt={0.5}>
                    {getPriorityBadge(0)}
                    {getPriorityBadge(1)}
                    {getPriorityBadge(2)}
                    {getPriorityBadge(3)}
                  </MDBox>
                </MDBox>

               
              </MDBox>
            </MDBox>
          </MDBox>

          <DataTable
            table={{
              ...dataTableData2,
              customRowAttrs: true,
            }}
            canSearch
          />
        </Card>
      </MDBox>
      <Footer />

      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        aria-labelledby="confirm-delete-dialog-title"
      >
        <DialogTitle id="confirm-delete-dialog-title">تأكيد الحذف</DialogTitle>
        <DialogContent>
          <DialogContentText>سيتم حذف بيانات هذا الحقل بشكل نهائي. هل أنت متأكد؟</DialogContentText>
        </DialogContent>
        <DialogActions>
          <MDButton onClick={handleConfirmDelete} color="error">
            نعم
          </MDButton>
          <MDButton onClick={handleCloseDialog} color="secondary">
            لا
          </MDButton>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
}

export default IssuesDataTables;
